import React from "react";
import moment from "moment/moment";

const FlightCancelled = ({ val }) => {
  return (
    <>
      <div className="booking-main-wrap">
        <div className="booking-wrap">
          <div>
            <div className="booking-icon-wrap">
              <img src="assets/images/my-trip/flight.svg" alt="err" />
            </div>
          </div>
          <div className="booking-lists">
            <div className="d-flex justify-content-center align-items-center">
              <h6 className="bold20 text-nowrap">
                Booking Type :{" "}
                {val.JourneyType === 2 ? "Round Trip" : "One Way"}
              </h6>
            </div>
            <h5 className="b-b-20">
              {" "}
              {moment(val.TravelDate).format("MMMM Do YYYY")}
            </h5>
            <div className="d-flex">
              <h6 className="b-medium-16">From : {val.origin}</h6>{" "}
              &nbsp;&nbsp;&nbsp;&nbsp;
              <h6 className="b-medium-16">To : {val.destination}</h6>
            </div>
            {val.params.Itinerary.Passenger.map((ele) => {
              if (ele.IsLeadPax === true) {
                return (
                  <h6 className="b-medium-14">
                    Booked By: {ele.Title} {ele.FirstName} {ele.LastName}
                  </h6>
                );
              }
            })}
            <h6 className="b-medium-14">
              Total Passengers {val.params.Itinerary.Passenger.length}
            </h6>
          </div>
        </div>
        <div className="cancelled-detail">
          <img src="assets/images/my-trip/cancelled.svg" alt="cancelled" />
        </div>
      </div>
    </>
  );
};

export default FlightCancelled;
